import i18n from '../../i18n';

const buildOperatorsByType = () => {
  const eq = { label: i18n.t('operators.equals'), value: '=' };
  const neq = { label: i18n.t('operators.notEquals'), value: '!=' };
  const contains = { label: i18n.t('operators.contains'), value: 'ilike' };
  const notContains = { label: i18n.t('operators.notContains'), value: 'not ilike' };
  const isIn = { label: i18n.t('operators.isIn'), value: 'in' };
  const isNotIn = { label: i18n.t('operators.isNotIn'), value: 'not in' };
  const containsIn = { label: i18n.t('operators.contains'), value: 'in' };
  const notContainsIn = { label: i18n.t('operators.notContains'), value: 'not in' };
  const greaterThan = { label: i18n.t('operators.greaterThan'), value: '>' };
  const lessThan = { label: i18n.t('operators.lessThan'), value: '<' };
  const greaterOrEqual = { label: i18n.t('operators.greaterOrEqual'), value: '>=' };
  const lessOrEqual = { label: i18n.t('operators.lessOrEqual'), value: '<=' };
  const before = { label: i18n.t('operators.before'), value: '<' };
  const after = { label: i18n.t('operators.after'), value: '>' };

  return {
    char: [eq, neq, contains, notContains],
    text: [eq, neq, contains, notContains],
    selection: [eq, neq, isIn, isNotIn],
    boolean: [eq, neq],
    integer: [eq, neq, greaterThan, lessThan, greaterOrEqual, lessOrEqual],
    float: [eq, neq, greaterThan, lessThan, greaterOrEqual, lessOrEqual],
    many2one: [eq, neq],
    many2many: [containsIn, notContainsIn],
    one2many: [containsIn, notContainsIn],
    date: [eq, neq, before, after],
    datetime: [eq, neq, before, after],
  };
};

export const OPERATORS_BY_TYPE = new Proxy({}, {
  get(_target, prop) {
    return buildOperatorsByType()[prop];
  }
});
